<template>
  <component
    :is="itemComponent"
    :data="completeData"
    :parent-key="modulesData && modulesData.fieldkey"
    :placeholder="placeholder"
    @delete="handleDelete(data.fieldkey)"
    @dropdownVisibleChange="dropdownVisibleChange"
    @change="handleChange"
  >
    <slot />
  </component>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import MyInput from './Input'
import MyInputList from './InputList'
import MySelect from './Select'
import MyRadio from './Radio'
import StarRadio from './StarRadio'
import MyCheckbox from './CheckBox'
import SelectTree from './SelectTree'
import DateTime from './DateTime'
import MyTag from './Tag'
import MyEditor from './Editor'
import MyFile from './File'
import MyArea from './Area'
import MyCascader from './Cascader'
import NotCanEditItem from './NotCanEdit'
import IsChangedItem from './IsChanged'
import IsSensitive from './Sensitive'
import { debounce } from '@/lib/utils'

export default {
  props: {
    'data': {
      type: [Object, Array, String, Boolean],
      default: () => ({})
    },
    'modulesData': {
      type: Object,
      default: () => { }
    },
    currentFrom: {
      type: [String, Number],
      default: () => ''
    }
  },
  data () {
    return {
      completeData: {},
      decorator: []
    }
  },

  computed: {
    itemComponent () {
      const inquiryId = this.$route.params.inquiryId
      let { fieldtype, isedit, ischanged, issensitive, fieldconfig = {} } = this.data
      if (issensitive && inquiryId) { // 敏感字段
        return IsSensitive
      }
      if (ischanged && inquiryId) { // 配置里删除
        return IsChangedItem
      }
      if (!isedit && inquiryId && fieldtype !== 'radioinfo_type') { // 不可编辑
        return NotCanEditItem
      }
      let component

      switch (fieldtype) {
        case 'text':
        case 'number':
        case 'ip':
          component = MyInput
          break
        case 'phone':
        case 'email':
          // component = this.$route.name === 'ClueCreate' || this.$route.name === 'ClueDetail' ? MyInput : MyInputList
          component = MyInputList
          break
        case 'select':
          component = MySelect
          break
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_type':
        case 'radioinfo_followup':
          if (fieldconfig.type && parseInt(fieldconfig.type) === 2) {
            component = StarRadio
          } else {
            component = MyRadio
          }
          break
        case 'checkbox':
          component = MyCheckbox
          break
        case 'editor':
          component = MyEditor
          break
        case 'select_tree':
          component = SelectTree
          break
        case 'datetime':
          component = DateTime
          break
        case 'tag':
          component = MyTag
          break
        case 'file':
          component = MyFile
          break
        case 'area':
          component = MyArea
          break
        // 接待信息
        case 'select_reception':
          component = MyCascader
          break
        case 'string':
          component = NotCanEditItem
          break
      }
      return component
    },

    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldtype = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig
      let spaceStr = this.$isEnglish ? ' ' : ''

      if (fieldtype === 'text' || fieldtype === 'ip' || fieldtype === 'number' || fieldtype === 'editor' || fieldtype === 'tag' || fieldtype === 'phone' || fieldtype === 'email') {
        return placeholder || this.$t('message["751"]') + spaceStr + fieldname
      } else {
        return placeholder || this.$t('message["855"]') + spaceStr + fieldname
      }
    }
  },

  watch: {
    data: {
      handler (val) {
        if (!val) return
        let { fieldvalue = '', fieldkey, fieldtype } = val || {}
        this.completeData = this.setCompleteData(val)
        // 跟进状态
        if (fieldkey === 'info_status' && fieldtype.indexOf('radio') !== -1) {
          this.toggleVisibleStatusModule(fieldvalue)
        }
        // 信息类型
        if (fieldkey === 'info_type' && fieldtype.indexOf('radio') !== -1) {
          this.toggleVisibleTypeModule(fieldvalue)
        }
      },
      deep: true,
      immediate: true
    }
  },

  async created () {
    let { fieldkey, fieldtype } = this.data || {}
    if (fieldkey === 'info_type' || fieldtype === 'radioinfo_type') {
      this.data.isexplain = true
    }
  },
  methods: {
    ...mapActions('inquery/relateData', [
      'fetchRelateTeamInfo'
    ]),
    ...mapMutations('inquery/detailData', ['UPDATE_IS_DEAL']),
    ...mapMutations('inquery/relateData', [
      'UPDATE_IS_DISCARD',
      'UPDATE_IS_INVALID'
    ]),

    // 完善data数据
    setCompleteData (data) {
      const { fieldtype, fieldvalue, fielddesc, isedit } = data
      switch (fieldtype) {
        case 'text':
        case 'ip':
        case 'number':
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_type':
        case 'radioinfo_followup':
        case 'editor':
        case 'datetime':
          data.fieldvalue = fieldvalue || ''
          break
        case 'phone':
        case 'email':
        case 'checkbox':
        case 'tag':
        case 'file':
          data.fieldvalue = fieldvalue || []
          break
        case 'select_tree':
        case 'area':
          data.fieldvalue = fieldvalue || {}
          break
        case 'select_reception':
          if (isedit) {
            data.fieldvalue = fieldvalue || []
          }
          // 设置不必须选到末级
          this.$set(data, 'isMustLast', false)
          data.isMustLast = false
          break
        case 'string':
          data.fieldvalue = fielddesc || fieldvalue || ''
          break
      }
      return data
    },
    /**
     * val 返回每个组件选中的value值
     */
    handleChange (val) {
      if (!this.data) return
      const { fieldtype = '', fieldkey = '' } = this.data || {}
      // Cascader组件传递给上一层的数据是data,不是data.fieldvlaue,这里特殊处理
      if (fieldtype === 'select_reception') {
        this.data.fieldvalue = val.value
      } else {
        this.data.fieldvalue = val
      }

      if (fieldtype === 'text' || fieldtype === 'number' || fieldtype === 'phone' || fieldtype === 'email' ||
        fieldtype === 'select' || fieldtype === 'editor' || fieldtype === 'tag') {
        // 录入页面和审核页面，字段值修改时，触发来源关联人员接口
        if (this.$route.name === 'InqueryCreate' || this.$route.name === 'InqueryDetail') {
          this.relateTeamInfo(this)
        }
      }
      // 跟进状态
      if (fieldkey === 'info_status' && fieldtype.indexOf('radio') !== -1) {
        this.toggleVisibleStatusModule(val)
      }
      // 信息类型
      if (fieldkey === 'info_type' && fieldtype.indexOf('radio') !== -1) {
        this.toggleVisibleTypeModule(val)
      }

      this.$emit('change', val)
    },
    toggleVisibleStatusModule (val) {
      if (val === '') return
      const { options = [] } = this.data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name
      // 是否选择成交
      this.UPDATE_IS_DEAL(name === this.$t('message["109"]'))
      // 是否选择丢单
      this.UPDATE_IS_DISCARD(name === this.$t('message["1690"]'))
    },
    toggleVisibleTypeModule (val) {
      if (val === '') return
      const { options = [] } = this.data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name

      // 是否选择无效
      this.UPDATE_IS_INVALID(name === this.$t('message["1766"]'))
    },

    /* 防抖：防止请求次数过多 */
    relateTeamInfo: debounce(async (_this) => { // 关联人员
      const { modulesData = {}, currentFrom = '' } = _this
      const { fieldkey = '', childObj = {} } = modulesData

      if (fieldkey === 'from_info' && childObj[currentFrom]) {
        const { fieldkey = '', child: childData = {} } = childObj[currentFrom]
        let params = {}
        params.fieldkey = fieldkey
        params.fromkv = {}

        for (let item of childData) {
          params.fromkv[item.fieldkey] = item.fieldvalue || ''
        }

        try {
          let chain = await _this.fetchRelateTeamInfo()
          chain
            .params(params)
            .onSuccess(res => {
            })
            .fetch()
        } catch (error) {
          console.log(error)
        }
      }
    }, 1000),

    handleDelete (fieldkey) {
      this.$emit('delete', this.modulesData, fieldkey)
    },
    dropdownVisibleChange (open) {
      this.$emit('dropdownVisibleChange', open)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
